import React, { Component } from 'react';
import Config from '../../config/Config';

export default class NotFound extends Component {
	constructor(props) {
		super(props);
		document.getElementById("sk-circle").style.display = "none";
		document.getElementById("myDiv").style.opacity = 1;
	}
	render() {
		return(
			<div id="wrapper" className='error404'>
				<div className="wrap">
					<div className="main-message">
						<h3><img src={Config.ASSETSPATH+'img/STEP_logo.png'} alt="Step Logo" /></h3>
						<h2>404 ERROR !</h2>
						<h1>Oops page not found</h1>
						<div className="search">
							<p>« Go Back »</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}